import React from 'react';
import { useIntl } from 'react-intl';

import { commonTheme } from 'app/shared/theme';
import { useAnalyticsContext } from 'app/shared/utils';
import { ThemeWrapper, Typography } from 'app/shared/components/atoms';
import { NavigationButton, SEO } from 'app/shared/components/molecules';
import Layout from 'app/shared/layouts/Main';

import GenericErrorScreen from './GenericErrorScreen';

interface GlobalErrorContentProps {
  'data-qaid'?: string;
  error?: string;
}

const GlobalErrorContent: React.FC<
  React.PropsWithChildren<GlobalErrorContentProps>
> = ({ error, 'data-qaid': qaId }) => {
  const { formatMessage } = useIntl();

  return (
    <GenericErrorScreen data-qaid={qaId}>
      <Typography textAlign="center">
        {error || formatMessage({ id: 'globalError.defaultErrorMessage' })}
      </Typography>
      <NavigationButton href="/">
        {formatMessage({ id: 'shared.backToHomepage' })}
      </NavigationButton>
    </GenericErrorScreen>
  );
};

export const GlobalError: React.FC<
  React.PropsWithChildren<{
    noLayout?: boolean;
    error?: any;
    displayError?: string;
  }>
> = ({ noLayout = false, error, displayError }) => {
  const { trackAnalyticsEvent } = useAnalyticsContext();

  trackAnalyticsEvent('Oh No Page Viewed', {
    title: '500 page',
    error,
    displayError,
    url: window.location.href,
  });

  return (
    <ThemeWrapper themeName="common">
      {noLayout ? (
        <GlobalErrorContent error={displayError} data-qaid="500-page" />
      ) : (
        <Layout
          data-qaid="500-page"
          useMinimalFooter
          backgroundColor={commonTheme.colors.primary.white.lighter}
        >
          <SEO title="Something went wrong" noIndex />
          <GlobalErrorContent error={displayError} />
        </Layout>
      )}
    </ThemeWrapper>
  );
};
